import { type AttachmentDocumentTypeOption } from '../domain/Document'
import { createShipperHttpClient } from '../infra/createShipperHttpClient'
import { ShipperRepository } from '../infra/ShipperRepository'

export type ListAttachmentDocumentTypesFactoryDependencies = {
  shipperRepository: ShipperRepository
}

export function listAttachmentDocumentTypesFactory({
  shipperRepository,
}: ListAttachmentDocumentTypesFactoryDependencies) {
  return async function (config?: {
    signal?: AbortSignal
  }): Promise<AttachmentDocumentTypeOption[]> {
    return shipperRepository.listAttachmentDocumentTypes(config)
  }
}

export function listAttachmentDocumentTypes(config?: {
  signal?: AbortSignal
}): Promise<AttachmentDocumentTypeOption[]> {
  const httpClient = createShipperHttpClient()
  const shipperRepository = new ShipperRepository({ httpClient })
  const listFn = listAttachmentDocumentTypesFactory({ shipperRepository })
  return listFn(config)
}
